import { Link } from "react-router-dom";

const SUPPORT_EMAIL = "support@herrellinteractive.com";

const cols = [
  {
    title: "Apps",
    links: [
      { to: "/beekeeper", label: "ApiaryKeeper" },
      { to: "/mileagekeeper", label: "MileageKeeper" },
      { to: "/evidencekeeper", label: "EvidenceKeeper" },
      { to: "/compare", label: "Compare Apps" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/roadmap", label: "Roadmap" },
      { to: "/security", label: "Privacy & Security" },
      { to: "/support", label: "Support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/delete-account", label: "Delete Account & Data" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-white/10 mt-8" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-5 py-12">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/favicon.png" alt="Herrell Interactive" className="w-9 h-9 rounded-md" />
            <span className="hi-serif text-lg text-[#f3ead4] tracking-wide">HERRELL INTERACTIVE</span>
          </div>
          <p className="hi-body text-sm text-white/65 mt-4 max-w-xs leading-relaxed">
            Practical software for business, home, family and the people who keep them running.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="footer-email"
            className="hi-body inline-block text-sm text-[#3b9bff] hover:underline mt-4"
          >
            {SUPPORT_EMAIL}
          </a>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="hi-body text-xs uppercase tracking-wider text-white/50 mb-3">{c.title}</h4>
            <ul className="space-y-2">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                    className="hi-body text-sm text-white/65 hover:text-[#3b9bff] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="hi-hairline w-full mt-10 mb-6" />

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
        <p className="hi-body text-xs text-white/55">
          © {new Date().getFullYear()} Herrell Interactive is owned and operated by Herrell Homestead LLC.
        </p>
        <p className="hi-body text-xs text-white/45">Faith · Family · Farm · Bees</p>
      </div>
    </div>
  </footer>
);

export default Footer;
